<template>
  <div class="login-firstTime">
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-7 loginLeft">
            <img src="assets/images/login-graphic.png" alt="" />
          </div>

          <div class="col-md-5 loginRight">
            <div class="loginWrapper">
              <div class="loginText">
                <h2>Please, confirm your registration:</h2>
                <p class="registeredPhone">
                  Enter the confirmation code that was sent to your phone:
                </p>
                <p class="registeredPhoneNum">
                  xxxxxxx{{ lastThreePhoneDigits }}
                </p>
              </div>

              <div class="loginControls regNo">
                <form action="form" @submit.prevent="setNewPassword">
                  <input
                    type="text"
                    maxlength="1"
                    id="digit1SetNewPass"
                    name="digit1"
                    v-model="digit1"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit2SetNewPass"
                    name="digit2"
                    v-model="digit2"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit3SetNewPass"
                    name="digit3"
                    v-model="digit3"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit4SetNewPass"
                    name="digit4"
                    v-model="digit4"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit5SetNewPass"
                    name="digit5"
                    v-model="digit5"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit6SetNewPass"
                    name="digit6"
                    v-model="digit6"
                    @keypress="onlyNumber"
                  />

                  <br /><br />

                  <input
                    name="password"
                    class="password"
                    type="password"
                    placeholder="New Password"
                    v-model="password"
                  />

                  <button
                    v-if="isSetNewPasswordButtonLoading === true"
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </button>
                  <button
                    v-if="isSetNewPasswordButtonLoading === false"
                    type="submit"
                  >
                    Send
                  </button>
                  <router-link v-bind:to="loginRoute" class="backToLogin"
                    >Back to login page</router-link
                  >
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "@/store/accounts/actions";
import routes from "@/constants/routes";

export default {
  created() {
    this.loginRoute = routes.LOGIN;
  },
  data: () => ({
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
    password: null
  }),
  computed: {
    lastThreePhoneDigits: {
      get() {
        return this.$store.state.accounts.phone.slice(
          this.$store.state.authentication.phone.length - 3
        );
      }
    },
    isSetNewPasswordButtonLoading: {
      get() {
        return this.$store.state.settings.isSetNewPasswordButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsSetNewPasswordButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    onlyNumber: function($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const symbol = String.fromCharCode(keyCode);

      if (/^\s*$/.test(symbol) || isNaN(symbol)) {
        $event.preventDefault();
      } else {
        const inputId = $event.target.id;

        switch (inputId) {
          case "digit1SetNewPass":
            this.digit1 = symbol;
            break;
          case "digit2SetNewPass":
            this.digit2 = symbol;
            break;
          case "digit3SetNewPass":
            this.digit3 = symbol;
            break;
          case "digit4SetNewPass":
            this.digit4 = symbol;
            break;
          case "digit5SetNewPass":
            this.digit5 = symbol;
            break;
          case "digit6SetNewPass":
            this.digit6 = symbol;
            break;
          default:
            break;
        }

        $event.preventDefault();
        $event.target.nextElementSibling.focus();
      }
    },
    setNewPassword: async function() {
      if (this.password == null || this.password == undefined) {
        this.$store.commit(
          "updateGenericErrorModalMessageMutation",
          "New Password was not entered"
        );
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", true);
        return;
      }

      if (!/\S/.test(this.password)) {
        this.$store.commit(
          "updateGenericErrorModalMessageMutation",
          "Password can not include only white spaces"
        );
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", true);
        return;
      }

      const formedPayload = {
        token: `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`,
        password: this.password
      };

      if (formedPayload.token.length != 6) {
        this.$store.commit(
          "updateGenericErrorModalMessageMutation",
          "Sms code was not entered"
        );
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", true);
        return;
      }

      this.isSetNewPasswordButtonLoading = true;
      await this.$store.dispatch(
        actions.POST_NEW_PASSWORD_DATA_TO_CHANGE_PASSWORD,
        formedPayload
      );
    }
  }
};
</script>
